import { API } from "../constants/api";
import useAuthAxios from "../utils/baseAxios";
import { useQuery } from "@tanstack/react-query";

const useKycDetails = () => {
  const axiosInstance = useAuthAxios();

  const getKycDetails = async () => {
    const response = await axiosInstance.get(API.getKycDetails);
    return response.data.data;
  };

  const { data: kycDetails, isLoading, error } = useQuery({
        queryKey: ["get-kyc-details"],
    queryFn: getKycDetails,
    retry: 1,   
  });

  return { data: kycDetails, isLoading, error };
};

export default useKycDetails;
